module.exports = __webpack_public_path__ + "static/media/silver.d8fa6e57.svg";